/**
 * Spec 085 (decision 2026-11-03, vault `decisions/dealer-portal-own-domain.md`) — the dealer portal has its
 * own address (`dealer-stage.garagat.ai`, `dealer.garagat.ai`) served by this same app. The host decides
 * which portal a visitor sees; accounts are still kept apart by identity's `WRONG_APP`.
 *
 * Hosts without a partner/dealer pair (localhost, previews) never redirect across hosts: both portals stay
 * reachable by path there (`/login`, `/dealer/login`).
 */

const DEALER_PREFIX = /^dealer([.-])/;
const PARTNER_PREFIX = /^partner([.-])/;

export function isDealerHost(hostname: string = window.location.hostname): boolean {
  return DEALER_PREFIX.test(hostname);
}

/** `https://dealer-stage.garagat.ai` for `partner-stage.garagat.ai`; null where there is no pair. */
export function dealerOrigin(location: Pick<Location, 'protocol' | 'hostname' | 'port'> = window.location): string | null {
  if (!PARTNER_PREFIX.test(location.hostname)) return null;
  return origin(location, location.hostname.replace(PARTNER_PREFIX, 'dealer$1'));
}

/** `https://partner-stage.garagat.ai` for `dealer-stage.garagat.ai`; null where there is no pair. */
export function partnerOrigin(location: Pick<Location, 'protocol' | 'hostname' | 'port'> = window.location): string | null {
  if (!DEALER_PREFIX.test(location.hostname)) return null;
  return origin(location, location.hostname.replace(DEALER_PREFIX, 'partner$1'));
}

function origin(location: Pick<Location, 'protocol' | 'port'>, hostname: string): string {
  return `${location.protocol}//${hostname}${location.port ? `:${location.port}` : ''}`;
}

/** Where the "use the other portal" link points: the other host when there is one, else the other path. */
export function otherLoginHref(target: 'dealer' | 'partner'): string {
  if (target === 'dealer') {
    const o = dealerOrigin();
    return o ? `${o}/` : '/dealer/login';
  }
  const o = partnerOrigin();
  return o ? `${o}/login` : '/login';
}
